
import Vue, { CreateElement, RenderContext, VNode } from "vue";
import { LikesStatistic } from "@scrile/api-provider/dist/api/LikeProvider";
import BaseIcon from "@/components/BaseIcon";

interface Props {
  likes: LikesStatistic | null;
}

export default Vue.extend({
  name: "ContentFeedLikes",
  functional: true,
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    const count = ctx.props.likes ? ctx.props.likes.count.toString() : "";
    const isLiked = ctx.props.likes && ctx.props.likes.liked;
    const icon = isLiked ? "sci-heart" : "sci-heart-outline";
    return h(
      "div",
      {
        class: [
          ...(Array.isArray(ctx.data.class) ? ctx.data.class : [ctx.data.class]),
          ctx.data.staticClass,
          "feed-likes px-1",
          isLiked ? "__liked" : "",
        ],
        on: ctx.listeners,
      },
      [
        h(BaseIcon, { attrs: { fontSize: 24 }, class: { "feed-likes__icon mr-1": true } }, [icon]),
        h("div", { class: { "feed-likes__count": true } }, [count]),
      ]
    );
  },
});
